<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑菜单按钮</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <div>
                    <el-row>
                        <el-col :span="24" class="item">
                            <el-input v-model="name" disabled></el-input>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24" class="item">
                            <div v-for="(item,index) in listRoleMenuRelDTO" v-bind:key="item.roleMenuRelCode" style="margin: 5px 0px;padding:20px;">

                                <div v-if="item.menuDTO != null">
                                    <span>{{ item.menuDTO.menuNamePath.replaceAll(',',"/") }}</span>

                                    <el-checkbox-group v-model="checkedEquipments[index]" @change="onChange($event,item.roleMenuRelCode)">
                                        <el-checkbox v-for="city in item.menuDTO.listMenuButton"
                                                     :label="city.menuButtonCode"
                                                     :key="city.menuButtonCode">{{city.buttonName}}</el-checkbox>
                                    </el-checkbox-group>

                                </div>

                            </div>
                        </el-col>
                    </el-row>

                </div>




            </div>
            <div class="modal-footer">
                <!--                <el-button :loading="loading" type="primary" @click="confirm('addForm')">修改</el-button>-->
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        data() {
            return {

                loading: false,


                name:'',
                listRoleMenuRelDTO:'',

                checkedEquipments: [],


            }
        },

        methods: {

            init(row){
                console.log(row);

                this.name = row.name;
                this.listRoleMenuRelDTO = row.listRoleMenuRelDTO;


                for(let i=0;i<this.listRoleMenuRelDTO.length;i++){
                    if(this.listRoleMenuRelDTO[i].menuDTO != null){

                        let checkArr = [];
                        for (let j = 0; j < this.listRoleMenuRelDTO[i].menuDTO.listMenuButtonSelected.length; j ++) {
                            checkArr.push(this.listRoleMenuRelDTO[i].menuDTO.listMenuButtonSelected[j].menuButtonCode)
                        }
                        this.checkedEquipments.push(checkArr)
                        if(checkArr.length > 0){
                            console.log(checkArr.toString());
                        }

                    }else{
                        this.checkedEquipments.push([]);
                    }

                }

            },




            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(addForm){

                console.log(addForm);

            },

            onChange(value,roleMenuRelCode) {

                console.log(value);
                console.log(roleMenuRelCode);

                //let checkedCount = value.length;
                //this.checkAll = checkedCount === this.cities.length;
                //this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;


                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RoleMenuRel/EditRoleMenuButtonRel",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        roleMenuRelCode:roleMenuRelCode,
                        listMenuButtonCode:value,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        //this.tableData = response.data.data.pageInfoRoleDTO.list;
                        //this.totalItems = response.data.data.pageInfoRoleDTO.total;
                    }
                }).catch(function (error) {
                    console.log(error);
                });



            }


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: 500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
